import React, { FC } from 'react';
import { Button } from 'react-bootstrap';
import { urls } from '../../services/Server';
import { AssetWithCalculatedStats } from '../../interfaces/interfaces';

interface Props {
  asset: AssetWithCalculatedStats;
}

const DeletePortfolioAsset: FC<Props> = ({ asset }) => {
  const confirmDelete = (event: React.FormEvent) => {
    if (
      !window.confirm(
        'Er du sikker på at du vil slette raden fra din portefølje?'
      )
    ) {
      event.preventDefault();
    }
  };
  const { type, id } = asset;
  const action = type === 'Crypto' ? urls.deleteCrypto : urls.deleteEquity;
  return (
    <form
      onSubmit={confirmDelete}
      className="float-left"
      action={action}
      method="post"
    >
      <input type="hidden" name="equityid" value={id} />
      <Button variant="danger" type="submit">
        Selg hele raden
      </Button>
    </form>
  );
};

export default DeletePortfolioAsset;
